import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import {
  setSearchCondition,
  setQuickSearchFlg,
  setQuickSearchResultFlg,
  searchCompanyList,
} from '../../actions/CompanyAction';
import {
  setInitMessage,
  setErrorMessage,
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import {
  INPUT,
  SEARCH_TARGET,
} from '../../../common/const';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import styles from './CompanyQuickSearchComponent.module.css';

class CompanyQuickSearchComponent extends Component {
  constructor() {
    super();
    this.state = {
      errFlag: false,
    };
  }

  onChangeSearchCondition = (val) => {
    const { setSearchConditionAct } = this.props;
    setSearchConditionAct(val);
  }

  /**
   * 検索条件詳細POPUPを表示する。
   */
  setQuickSearchFlg = () => {
    const { setQuickSearchFlgAct } = this.props;
    setQuickSearchFlgAct(true);
  }

  /**
   * 検索条件を元に企業検索を行い、検索結果を一時保存領域「企業検索結果一覧」に保持する。
   */
  searchCompanyList = async () => {
    const {
      searchCondition,
      quickSearchCondition,
      setSystemLodingFLgAct,
      setQuickSearchResultFlgAct,
      searchCompanyListAct,
      setErrorMessageAct,
      setInitMessageAct,
      setQuickSearchFlgAct,
    } = this.props;

    // 検索詳細設定の非表示
    setQuickSearchFlgAct(false);

    // エラーメッセージ初期化
    setInitMessageAct();
    // 検索条件の入力値チェック
    const msgs = [];

    // 検索条件が入力されている場合、スペース除去
    const searchWord = searchCondition ? searchCondition.trim() : searchCondition;

    // 必須チェック
    validator.checkRequired(INPUT.COMPANY.SEARCH_CONDITION, searchWord, msgs);

    const msgWords = [];
    let inputItem;
    if (quickSearchCondition.search_target === SEARCH_TARGET.DUNS) {
      inputItem = INPUT.COMPANY.DUNS;
      // 検索対象がDUNSの場合、文字種、桁数チェックを行う
      // 文字種チェック(半角数字)
      validator.checkChar(searchWord, VALIDATOR_CONST.PATERN_NUM, msgWords);
      // 桁数チェック
      validator.checkLength(searchWord, 9, msgWords);
    } else if (quickSearchCondition.search_target === SEARCH_TARGET.KIGYO_CODE) {
      inputItem = INPUT.COMPANY.KIGYO_CODE;
      // 検索対象がTSRコードの場合、文字種、桁数チェックを行う
      // 文字種チェック(半角数字)
      validator.checkChar(searchWord, VALIDATOR_CONST.PATERN_NUM, msgWords);
      // 桁数チェック
      validator.checkLength(searchWord, 9, msgWords);
    } else if (quickSearchCondition.search_target === SEARCH_TARGET.CORPORATE_NUMBER) {
      inputItem = INPUT.COMPANY.CORPORATE_NUMBER;
      // 検索対象が法人番号の場合、文字種、桁数チェックを行う
      // 文字種チェック(半角数字)
      validator.checkChar(searchWord, VALIDATOR_CONST.PATERN_NUM, msgWords);
      // 桁数チェック
      validator.checkLength(searchWord, 13, msgWords);
    } else {
      inputItem = INPUT.COMPANY.COMPANY_NAME;
      // 検索対象が企業名の場合、桁数チェックを行う
      // 文字種チェック(全角文字)
      validator.checkChar(searchWord, VALIDATOR_CONST.PATERN_FULL_WIDTH, msgWords);
      // 桁数チェック
      validator.checkMaxLength(searchWord, 30, msgWords);
    }
    if (msgWords.length !== 0) {
      // エラーメッセージ作成
      msgs.push(getMessage(ERROR.E08005, inputItem, msgWords.join(',')));
    }
    // 入力エラーがあった場合、検索を行わず、画面にメッセージを表示
    if (msgs.length !== 0) {
      this.setState({
        errFlag: true,
      });
      setErrorMessageAct(msgs);
      return;
    }

    this.setState({
      errFlag: false,
    });
    // エンターキー連打制御
    document.activeElement.blur();
    setSystemLodingFLgAct(true);
    // 検索処理を実行し、一時保存領域で保持する
    const ret = await searchCompanyListAct(searchWord);
    setQuickSearchResultFlgAct(ret);
    setSystemLodingFLgAct(false);
  }

  render() {
    const { searchCondition } = this.props;
    const { errFlag } = this.state;
    return (
      <div className={`${styles.searchcompanyfield}`}>
        <TextField
          // id="searchCondition"
          size="small"
          className={styles.inputTextField}
          variant="outlined"
          value={searchCondition || ''}
          placeholder="検索"
          onFocus={this.setQuickSearchFlg}
          onChange={(ev) => this.onChangeSearchCondition(ev.target.value)}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') {
              this.searchCompanyList();
            }
          }}
          error={errFlag}
          InputProps={{
            className: styles.inputPropsIconButton,
            endAdornment: (
              <InputAdornment position="end" className={`${styles.inputAdornment}`}>
                <IconButton
                  color="primary"
                  onClick={() => this.searchCompanyList()}
                  className={`${styles.iconButton} ${styles.tooltip}`}
                >
                  <SearchIcon className={styles.serchIcon} />
                  <div className={`${styles.description}`}>検索</div>
                </IconButton>
              </InputAdornment>
            ),
            classes: {
              notchedOutline: styles.notchedOutline, // 外枠の色を変更
            },
          }}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // QuickSearchの入力文字
    searchCondition: state.company.searchCondition,
    // 検索結果一覧の表示フラグ
    quickSearchCondition: state.company.quickSearchCondition,
  }),
  (dispatch) => ({
    setSearchConditionAct: (str) => dispatch(setSearchCondition(str)),
    setQuickSearchFlgAct: (bool) => dispatch(setQuickSearchFlg(bool)),
    setQuickSearchResultFlgAct: (bool) => dispatch(setQuickSearchResultFlg(bool)),
    searchCompanyListAct: (obj) => dispatch(searchCompanyList(obj)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setErrorMessageAct: (str) => dispatch(setErrorMessage(str)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(CompanyQuickSearchComponent);
